import { Box, TextField } from "@mui/material";
import CustomInputCell from "./CustomInputCell";

export const taggedMrqMaterialsCols = [
  {
    accessorKey: "tagNumbers",
    header: "Part/Tag/Mark #",
    enableEditing: false,
    size: 100,
    Cell: ({ row }) => {
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return (
              <p key={i}>
                - {m.taggedMaterial?.tagNumber || m.bulkMaterial?.item}
              </p>
            );
          })}
        </Box>
      );
    },
  },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 200,
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
    enableEditing: false,
    size: 50,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;
      const isShell = row.original?.costCode?.toLowerCase().includes("shell");

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return isShell ? qty : formatNumber(Number(qty));
    },
  },
  {
    header: "Unit",
    accessorKey: "unit",
    enableEditing: false,
    size: 50,
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      console.log("poManager", row.original);
      if (row.original.unit) {
        return row.original.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
  },
  {
    header: "Remarks",
    accessorKey: "remarks",
    enableEditing: false,
    size: 150,
  },
];

export const bulkMrqMaterialsCols = [
  {
    accessorKey: "bulkMaterial.item",
    header: "Items",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      console.log({ row: row.original });
      return (
        <Box>
          {row.original.materials
            ?.map((m) => m?.bulkMaterial?.item)
            .sort()
            .map((item, i) => {
              return <p key={i}>- {item}</p>;
            })}
        </Box>
      );
    },
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  {
    accessorKey: "materialCode",
    header: "Material Code",
    enableEditing: false,

    size: 120,
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 120,
  },
];

export const bulkDescriptionMrqMaterialsColsEdit = (onChange = () => {}) => [
  {
    accessorKey: "markNumber",
    header: "Mark #",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      // console.log({ row: row.original });
      return (
        <Box>
          {row.original.materials
            ?.map((m) => m?.bulkMaterial?.markNumber || m?.markNumber)
            .sort()
            .map((markNumber, i) => {
              return <p key={i}>- {markNumber}</p>;
            })}
        </Box>
      );
    },
  },

  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.[0]?.costCode}</Box>;
    },
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 230,
  },

  {
    accessorKey: "length",
    header: "Dimension",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      // console.log("row", row.original);
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      let qty = 0;

      row.original.materials?.forEach((m) => {
        if (isPipe) qty += Number(m?.length) * Number(m?.quantity) || 0;
      });
      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }
      return isPlate ? (
        <CustomInputCell
          name="dimension"
          row={row}
          onChange={onChange}
          type="string"
        />
      ) : qty !== 0 ? (
        formatNumber(Number(qty))
      ) : (
        ""
      );
    },
  },

  {
    accessorKey: "unit",
    header: "Unit",
    enableEditing: false,

    size: 60,

    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      if (isPlate && !isHead) {
        return (
          <CustomInputCell
            name="unit"
            row={row}
            onChange={onChange}
            type="string"
          />
        );
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
  },
  {
    accessorKey: "reqQty",
    header: "Req. Qty",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      let pipingQty = 0;

      row.original.materials?.forEach((m) => {
        if (isPipe) pipingQty += Number(m?.length) * Number(m?.quantity) || 0;
      });
      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return isPipe ? (
        pipingQty
      ) : isPlate && !isHead ? (
        <CustomInputCell
          name="reqQty"
          row={row}
          onChange={onChange}
          placeholder="Add Qty"
        />
      ) : (
        formatNumber(Number(qty))
      );
    },
  },
  {
    accessorKey: "quantity",
    header: "Procured Qty",
    enableEditing: false,
    grow: false,
    size: 10,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="quantity"
          row={row}
          onChange={onChange}
          placeholder="Add Quantity"
        />
      );
    },
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 70,
    Cell: ({ row }) => {
      return (
        <CustomInputCell
          name="remarks"
          row={row}
          onChange={onChange}
          type="string"
        />
      );
    },
  },
];

export const bulkDescriptionMrqMaterialsCols = [
  {
    accessorKey: "costCode",
    header: "Cost Code",
    enableEditing: false,
    grow: false,
    size: 60,
    Cell: ({ row }) => {
      return <Box>{row.original.materials?.[0]?.costCode}</Box>;
    },
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 230,
  },

  {
    accessorKey: "unit",
    header: "Unit",
    enableEditing: false,

    size: 60,
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      if (row.original.unit) {
        return row.original.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
  },

  {
    accessorKey: "quantity",
    header: "Procured Qty",
    enableEditing: false,
    grow: false,
    size: 10,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    grow: false,
    size: 250,
  },
];
